import React, { useState } from 'react';
import './RxCompass.css';

const RxCompass = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="rx-container">
            <h1 className="rx-title">RxCompass</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b53d785e-5300-418d-9cea-b2fa25672faf&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="rx-box">
                <div className="rx-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="rx-faq-section">
                <h2 className="rx-faq-title">Frequently Asked Questions</h2>
                <div className="rx-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`rx-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="rx-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="rx-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`rx-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RxCompass;